import type { ProductMainOffer } from 'src/types';
import { ConditionEnum } from './types';
import type { IProductCondition } from './types';
import type { IFilter } from 'src/components/price-list/types';
import { FilterType } from 'src/components/price-list/types';
import type { TranslateFunc } from 'src/components/translate';

export const getCondition = (
  name: ConditionEnum.NEW | ConditionEnum.USED,
  count: number
): IProductCondition => {
  return {
    name,
    from: 0,
    to: 0,
    count,
  };
};

export const getProductConditionValues = (
  offers: ProductMainOffer[]
): IProductCondition[] => {
  const usedOffers = offers.filter(x => x.condition !== ConditionEnum.NEW);
  const newOffers = offers.filter(x => x.condition === ConditionEnum.NEW);

  if (!usedOffers.length) {
    return [];
  }

  const conditionList: IProductCondition[] = [];
  conditionList.push(getCondition(ConditionEnum.NEW, newOffers.length));
  conditionList.push(getCondition(ConditionEnum.USED, usedOffers.length));
  return conditionList;
};

export const resetVariantFilters = (filters: IFilter[]): IFilter[] => {
  const variantFilterTypes = [
    FilterType.VARIANT_SIZE,
    FilterType.VARIANT_COLOR,
  ];
  const updatedFilters = filters
    .filter(filter => variantFilterTypes.includes(filter.type))
    .map(filter => {
      return { ...filter, active: false, selection: [] };
    });
  return updatedFilters;
};

export const getConditionName = (
  type: ConditionEnum.NEW | ConditionEnum.USED,
  t: TranslateFunc
): string => {
  if (type === ConditionEnum.USED) {
    return t('product', 'price-filter.used-short');
  }
  return t('product', 'price-filter.new');
};
